import React from "react";
import Csr from "./Csr";
import Challenges from "./Challenges";

const CsrAndChallengesSection = () => {
  return (
    <>
      <div className="csr-activities-area">
        <div className="container">
          <div className="row">
            <Csr />
            <Challenges />
          </div>
        </div>
      </div>
    </>
  );
};

export default CsrAndChallengesSection;
